// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")

// Advisory - Energy Billing
const CommunityBilling = (params) => {
  
  useEffect(() => {    

    document.title = "HELIAS - Asesoramiento: Comunidad de vecinos"     
    document.querySelector('meta[name="description"]').setAttribute("content", "Consideraciones a tener en cuenta para reducir tu factura de luz.");
    
    console.log("Abro asesoramiento para el contrato de luz.")    

  });

  function obtenerPotenciaMaximaContratada(){

    var configPotencia = params.objDatosDashboard.InstallationData.GeneralInfo.PowerConfiguration.split("#")
    var potenciaMaxima = 0
    var potenciaTemp = 0

    for(var x=0; x<configPotencia.length; x++){

      potenciaTemp = configPotencia[x].split("|")[0]

      if(potenciaTemp > potenciaMaxima){
        potenciaMaxima = potenciaTemp
      }

    }

    return potenciaMaxima

  }

  function obtenerConsumoMaximoHistorico(){

    var consumoMaximoHistorico = params.objDatosDashboard.SelfConsumptionAndSavingsData.HistoricalMaxPowerConsumption.Value.replace(".","")

    consumoMaximoHistorico = parseFloat(parseFloat(consumoMaximoHistorico)/1000).toFixed(2)

    return consumoMaximoHistorico

  }

  function obtenerConclusionPotenciaContratada(){

    var potenciaMaximaContratada = obtenerPotenciaMaximaContratada()
    var consumoMaximoHistorico = obtenerConsumoMaximoHistorico()    
    var numeroExcesosPotenciaDesdeRegistro = parseInt(params.objDatosDashboard.SelfConsumptionAndSavingsData.SinceRegistrationPowerExcessesCount)    
    var tsRegistro = parseInt(params.objDatosDashboard.SelfConsumptionAndSavingsData.SinceRegistrationlastUpdate)
    var tsAhora = parseInt(Date.now()/1000)    
    var segundosDesdeRegistro = parseInt(tsAhora - tsRegistro)
    var numeroMesesDesdeRegistro = parseInt((segundosDesdeRegistro/86400)/30)
    var mediaExcesosMensuales = parseInt(numeroExcesosPotenciaDesdeRegistro / numeroMesesDesdeRegistro)    
    var conclusionPotencia = ""

    if(numeroMesesDesdeRegistro < 1){
      conclusionPotencia = " Todavía es pronto para sacar conclusiones, ***me falta monitorizar vuestra instalación más tiempo***. Cuando lo tenga claro os avisaré para que la subáis, la bajéis o la dejéis como está."
    }
    else{

      conclusionPotencia = " Vuestra potencia máxima contratada es de "+new Intl.NumberFormat('en-DE').format(potenciaMaximaContratada)+" kW. "

      if(consumoMaximoHistorico > potenciaMaximaContratada){ //Si he tenido excesos
        if(mediaExcesosMensuales >= 1){          
          conclusionPotencia = conclusionPotencia + "El caso es que vuestro consumo máximo ha sido de "+new Intl.NumberFormat('en-DE').format(consumoMaximoHistorico)+"kW y veo que tenéis muchos excesos de potencia, "+mediaExcesosMensuales+" de media al mes, por lo que es más que probable que os penalicen en la factura. La solución a esto sería subir la potencia a "+new Intl.NumberFormat('en-DE').format(parseFloat(parseFloat(consumoMaximoHistorico)+0.051).toFixed(1))+" kW, pero os cobrarían unos 46€ por subirla y además pagaríais "+obtenerPagoDeMasFacturaPorSubidaPotencia(parseFloat(parseFloat(consumoMaximoHistorico)+0.051))+"€ más al mes en la factura. Para evitar esto ***os aconsejo que consideréis mis avisos cuando haya algún exceso para ver si hay algo que se pueda apagar o que configuréis alguna regla*** para automatizarlo. En caso contrario no os quedará otra que subir la potencia ya que os saldrá más barato que las penalizaciones."
        }
        else{
          conclusionPotencia = conclusionPotencia + "Desde que os registrasteis vuestro consumo máximo ha sido de "+new Intl.NumberFormat('en-DE').format(consumoMaximoHistorico)+" kW, pero vuestros excesos de potencia han sido muy puntuales. ***Os recomiendo que sigáis con la potencia que tenéis actualmente***."
        }
      }
      else{ //No ha tenido excesos, puede bajarla
        if(consumoMaximoHistorico <= 2){
          conclusionPotencia = conclusionPotencia + "Desde que os registrasteis nunca la habéis superado, así que podéis bajarla a 2 kW."
        }
        else{
          conclusionPotencia = conclusionPotencia + "Desde que os registrasteis nunca la habéis superado, así que ***podéis bajarla a "+new Intl.NumberFormat('en-DE').format(parseFloat(consumoMaximoHistorico).toFixed(1))+" kW***. Aun así os recomiendo que miréis en vuestra última factura y comprobéis cuál ha sido el máximo de vuestro último año, en caso de que difiera de esto tened en cuenta el valor de la factura."
        }
        
      }
    }

    return (
      <>{conclusionPotencia.split("***")[0]}<strong>{conclusionPotencia.split("***")[1]}</strong>{conclusionPotencia.split("***")[2]}</>
    )

  }

  function obtenerPagoDeMasFacturaPorSubidaPotencia(nuevaPotencia){

    var pagoDeMasFactura = 0
    var configuracionPotencia = params.objDatosDashboard.InstallationData.GeneralInfo.PowerConfiguration.split("#")
    var costeActualPotencia = 0

    for(var x=0; x < configuracionPotencia.length; x++){
      try{
        costeActualPotencia = costeActualPotencia + (parseFloat(configuracionPotencia[x].split("|")[0]) * 30 * parseFloat(configuracionPotencia[x].split("|")[1]))
      }
      catch(error){
        console.log(error)
      }
    }

    for(var y=0; y < configuracionPotencia.length; y++){
      try{
        pagoDeMasFactura = pagoDeMasFactura + (nuevaPotencia * 30 * parseFloat(configuracionPotencia[y].split("|")[1]))
      }
      catch(error){
        console.log(error)
      }
    }

    pagoDeMasFactura = parseFloat(pagoDeMasFactura - costeActualPotencia).toFixed(2)

    return new Intl.NumberFormat('en-DE').format(pagoDeMasFactura)

  }

  return (      
    <main className="no-background">

      <section id="welcome-01" className="step">
        <div className="content-wrapper">          

            <div className="vertical gap-02">

              <p>Esta es la forma de ahorrar en las comunidades de vecinos:</p>
              
              <ul className="default-list">                            
              { initialConfigCommonJS.existeSesion() ?                    
                  <>
                    <li className="success"><strong>Sustituid todas las luces que tengáis por luces led, incluso las luces de emergencia</strong>. El ahorro del consumo será altísimo (en torno al 92% si por ejemplo tenéis luces halógenas) y la amortización rapidísima.</li>
                    <li className="success"><strong>Revisad la potencia contratada</strong> con la comercializadora de luz.{obtenerConclusionPotenciaContratada()} También os recomendaría que:</li>
                    <ul className="default-list">
                      <li>Solicitéis a vuestra empresa de ascensores un <strong>certificado de potencia de los ascensores</strong> que tengáis. Con este certificado ya tenéis el mínimo de lo que necesitáis. Obviamente a eso habría que sumarle la parte de potencia de las zonas comunes.</li>                  
                      
                      <li>Si esto os parece complicado también podéis llamar a un electricista para que os tome medidas y os recomiende la potencia óptima para vuestra instalación.</li>
                    </ul>               
                    <li className="success">Que <strong>la energía que consumís la paguéis a un precio mínimo</strong>.</li>
                    { Object.keys(params.objDatosDashboard.FVData ).length === 0 ?
                      <></>                              
                    :
                      <li className="success">Que <strong>la energía que volquéis a la red os la paguen a un precio justo</strong>.</li>                              
                    }  
                  </>
                  :
                  <>
                  {/* METER LOS COMENTARIOS ADICIONALES PARA CONSULTAS PÚBLICAS */}
                    <li className="success"><strong>Sustituid todas las luces que tengáis por luces led, incluso las luces de emergencia</strong>. El ahorro del consumo será altísimo (en torno al 92% si por ejemplo tenéis luces halógenas) y la amortización rapidísima.</li>
                    <li className="success"><strong>Revisad la potencia contratada</strong> con la comercializadora de luz. Os recomiendo que:</li>
                    <ul className="default-list">
                      <li>Solicitéis a vuestra empresa de ascensores un <strong>certificado de potencia de los ascensores</strong> que tengáis. Con este certificado ya tenéis el mínimo de lo que necesitáis. Obviamente a eso habría que sumarle la parte de potencia de las zonas comunes.</li>                                        
                      <li>Si esto os parece complicado también podéis llamar a un electricista para que os tome medidas y os recomiende la potencia óptima para vuestra instalación.</li>
                    </ul>                                   
                    <li className="success">Que <strong>la energía que consumís la paguéis a un precio mínimo</strong>. Para saber si vuestra tarifa de luz es razonable os animaría a usar nuestro <a href="https://www.fevergy.com/12-Facturas" className="link inline-link" target="_blank" rel="noopener noreferrer">servicio 12 facturas</a>.</li>
                    <li className="success">Que <strong>la energía que volquéis a la red os la paguen a un precio justo</strong>. Si además tenéis paneles solares, debéis fijaros bien en el precio de venta de vuestro excedente. Os recomendaría que tengáis tarifa de mercado libre ya que suelen dar mejor precio de venta. Para tener una referencia podéis consultar <a href="https://selectra.es/autoconsumo/info/tarifas" className="link inline-link" target="_blank" rel="noopener noreferrer">esta web</a>, mirar el "Precio medio de excedentes" para mercado libre y si lo que os pagan ahora es menor consultar otras comercializadoras que os mejoren ese precio.</li>           
                  </>
                }
              </ul>

              { initialConfigCommonJS.existeSesion() ?
                  <></>
                :
                  <p>Por último recordad que una de las ventajas de tener una suscripción en Helias es que toda esta información la revisaré en tiempo real, con datos exactos de vuestro medidor y cuando detecte qué necesitáis os lo notificaré. De esta manera os despreocuparéis y tendréis siempre la certeza de que tenéis un contrato acorde a vuestros consumos y que siempre estaréis pagando lo menos posible.</p>
              }

            </div>
            
            <fieldset>            
              <button className="button primary full-width" onClick={() => params.seleccionarOpcionAdvisory("FeesAnalyzer")}>Comprobemos vuestras tarifas</button>         
            </fieldset>            
          
        </div>        

      </section>

    </main>
  )
}

export default CommunityBilling